module.exports = __webpack_public_path__ + "images/assets/296b331d07f29fdb401384d0fc7b5252.svg";